<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <fieldset>
    <ItpFormGroup
      name="service"
      :label="'Service'|pgettext('ContractService')"
      labelColsMd="3"
      contentColsMd="9"
      :labelAlign="labelAlign"
      :helpTooltip="'Select the product or service the invoice line refers to.'|pgettext('ContractService|Tooltip')"
      required
    >
      <ItpFormSelect2
        name="client"
        v-model="item.service"
        bind-object
        :options="services"
        textField="name"
        :readonly="readonly"
        @optionSelected="evh_6466705138206980_optionSelected($event, {})"
      >
      </ItpFormSelect2>
    </ItpFormGroup>
    <ItpFormGroup
      labelColsMd="3"
      contentColsMd="9"
      name="invoice_group_id"
      :label="'Invoice Group'|pgettext('ContractService')"
      :labelAlign="labelAlign"
      :helpTooltip="'The invoice group this service belongs to.'|pgettext('ContractService|Tooltip')"
    >
      <ItpFormSelect2
        name="invoice_group_id"
        v-model="item.invoice_group_id"
        :multiple="b_3943151158818434_multiple"
        :options="invoiceGroups"
        valueField="id"
        textField="name"
        clearable
        :readonly="readonly"
      >
      </ItpFormSelect2>
    </ItpFormGroup>
    <ItpFormGroup
      labelColsMd="3"
      name="intermediated_service"
      :label="'Intermediated service'|pgettext('ContractService')"
      :labelAlign="labelAlign"
      :helpTooltip="'Select this option if the service is provided via an intermediary party.'|pgettext('ContractService|Tooltip')"
    >
      <ItpFormCheckbox
        name="intermediated_service"
        v-model="item.intermediated_service"
        :readonly="readonly"
      >
      </ItpFormCheckbox>
    </ItpFormGroup>
    <ItpFormGroup
      name="valid_from"
      :label="'Valid from'|pgettext('ContractService')"
      labelColsMd="3"
      contentColsMd="4"
      :labelAlign="labelAlign"
      :helpTooltip="'Specifies the start date of the service period.'|pgettext('ContractService|Tooltip')"
    >
      <ItpFormDatetime
        name="valid_from"
        v-model="item.valid_from"
        required
        :readonly="readonly"
      >
      </ItpFormDatetime>
    </ItpFormGroup>
    <ItpFormGroup
      name="valid_to"
      :label="'Valid to'|pgettext('ContractService')"
      labelColsMd="3"
      contentColsMd="4"
      :labelAlign="labelAlign"
      :helpTooltip="'The service end date. Set only if it\'s different from the contract\'s end date.'|pgettext('ContractService|Tooltip')"
    >
      <ItpFormDatetime
        name="valid_to"
        v-model="item.valid_to"
        :readonly="readonly"
      >
      </ItpFormDatetime>
    </ItpFormGroup>
    <ItpFormGroup
      name="valid_to"
      :label="'Description'|pgettext('ContractService')"
      labelColsMd="3"
      contentColsMd="9"
      :labelAlign="labelAlign"
      :helpTooltip="'Internal notes for reference only. Not visible externally.'|pgettext('ContractService|Tooltip')"
    >
      <ItpFormTextarea
        name="description"
        v-model="item.description"
        :readonly="readonly"
        rows="5"
      >
      </ItpFormTextarea>
    </ItpFormGroup>
  </fieldset>
  <hr>
  </hr>
  <fieldset>
    <legend>
      {{ 'Invoicing'|pgettext('ContractServiceEditor|Section') }}
    </legend>
    <ItpFormGroup
      labelColsMd="3"
      contentColsMd="6"
      name="billing_category"
      :label="'Billing category'|pgettext('ContractService')"
      :labelAlign="labelAlign"
      :helpTooltip="'The invoice category this service should be assigned to when billed. New values entered will be saved for future use.'|pgettext('ContractService|Help|BillingCategory')"
    >
      <ItpFormSelect2
        name="billing_category"
        taggable
        :options="billingCategories"
        v-model="item.billing_category"
        :readonly="item.readonly"
        valueField="name"
        textField="name"
      >
      </ItpFormSelect2>
    </ItpFormGroup>
    <ItpFormGroup
      name="name"
      :label="'Name'|pgettext('ContractService')"
      labelColsMd="3"
      contentColsMd="9"
      :labelAlign="labelAlign"
      :helpTooltip="'This text will appear on the invice line.'|pgettext('ContractService|Tooltip')"
      required
    >
      <ItpFormInput
        name="name"
        v-model="item.name"
        required
        :readonly="readonly"
      >
      </ItpFormInput>
    </ItpFormGroup>
    <ItpFormGroup
      name="name"
      :label="'Name(s)'|pgettext('ContractService')"
      labelColsMd="3"
      contentColsMd="9"
      :labelAlign="labelAlign"
      :helpTooltip="'This text will appear on the invice line.'|pgettext('ContractService|Tooltip')"
      required
    >
      <UCContractServiceItemNameEditor
        v-model="item.invoice_item_name"
        :readonly="readonly"
      >
      </UCContractServiceItemNameEditor>
    </ItpFormGroup>
    <ItpFormGroup
      labelColsMd="3"
      contentColsMd="9"
    >
      <hr
        class="dots"
      >
      </hr>
    </ItpFormGroup>
    <ItpFormGroup
      name="invoice_notes"
      :label="'Invoice notes'|pgettext('ContractServiceFee')"
      labelColsMd="3"
      contentColsMd="9"
      :labelAlign="labelAlign"
      :helpTooltip="'Note to display on the invoice line.'|pgettext('ContractService|Tooltip')"
    >
      <ItpFormTextarea
        name="fee_notes"
        v-model="item.invoice_notes"
        :readonly="readonly"
      >
      </ItpFormTextarea>
    </ItpFormGroup>
    <ItpFormGroup
      name="billing_frequency"
      :label="'Billing frequency'|pgettext('ContractService')"
      labelColsMd="3"
      contentColsMd="3"
      :labelAlign="labelAlign"
      :helpTooltip="'The cycle length of issuing the invoices.'|pgettext('ContractService|Tooltip')"
    >
      <BillingFrequencySelector
        v-model="item.billing_frequency"
        :readonly="readonly"
      >
      </BillingFrequencySelector>
    </ItpFormGroup>
    <ItpFormGroup
      name="billing_date_rule"
      :label="'Billing date rule'|pgettext('ContractService')"
      labelColsMd="3"
      contentColsMd="9"
      :labelAlign="labelAlign"
      :helpTooltip="'The cycle length of issuing the invoices.'|pgettext('ContractService|Tooltip')"
    >
      <BillingDateRuleFields
        v-model="item.billing_date_rule"
        :readonly="readonly"
      >
      </BillingDateRuleFields>
    </ItpFormGroup>
    <ItpFormGroup
      labelColsMd="3"
      contentColsMd="9"
    >
      <hr
        class="dots"
      >
      </hr>
    </ItpFormGroup>
    <ItpFormGroup
      name="due_date_rule"
      :label="'Due date rule'|pgettext('ContractService')"
      labelColsMd="3"
      contentColsMd="9"
      :labelAlign="labelAlign"
      :helpTooltip="'The rule of calculating the payment dates.'|pgettext('ContractService|Tooltip')"
    >
      <DueDateRuleFields
        v-model="item.due_date_rule"
        :readonly="readonly"
      >
      </DueDateRuleFields>
    </ItpFormGroup>
    <ItpFormGroup
      labelColsMd="3"
      contentColsMd="9"
    >
      <hr
        class="dots"
      >
      </hr>
    </ItpFormGroup>
    <ItpFormGroup
      name="billing_currency"
      :label="'Billing currency'|pgettext('ContractService')"
      labelColsMd="3"
      contentColsMd="3"
      :labelAlign="labelAlign"
      :helpTooltip="'The currency to use on the invoice.'|pgettext('ContractService|Tooltip')"
    >
      <BillingCurrencySelector
        v-model="item.billing_currency"
        :readonly="readonly"
      >
      </BillingCurrencySelector>
    </ItpFormGroup>
    <ItpFormGroup
      name="exchange_rate_source"
      :label="'Exchange rate source'|pgettext('ContractService')"
      labelColsMd="3"
      contentColsMd="3"
      :labelAlign="labelAlign"
      :helpTooltip="'The currency exchange rate\'s provider.'|pgettext('ContractService|Tooltip')"
    >
      <ExchangeRateSourceSelector
        v-model="item.exchange_rate_source"
        :readonly="readonly"
      >
      </ExchangeRateSourceSelector>
    </ItpFormGroup>
    <ItpFormGroup
      name="exchange_rate_source_spec"
      :label="'Exchange rate source specification'|pgettext('ContractService')"
      labelColsMd="3"
      contentColsMd="3"
      :labelAlign="labelAlign"
      :helpTooltip="'The currency exchange rate configuration.'|pgettext('ContractService|Tooltip')"
    >
      <ExchangeRateSourceSpecEditor
        v-model="item.exchange_rate_source_spec"
        :readonly="readonly"
      >
      </ExchangeRateSourceSpecEditor>
    </ItpFormGroup>
    <ItpFormGroup
      name="exchange_rate_date_rule"
      :label="'Exchange rate date rule'|pgettext('ContractService')"
      labelColsMd="3"
      contentColsMd="9"
      :labelAlign="labelAlign"
      :helpTooltip="'The date used to determine the exchange rate for billing purposes.'|pgettext('ContractService|Tooltip')"
    >
      <ExchangeRateDateRuleFields
        v-model="item.exchange_rate_date_rule"
        :readonly="readonly"
      >
      </ExchangeRateDateRuleFields>
    </ItpFormGroup>
  </fieldset>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class FieldsetContractService extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: String,
    default: "right",
  })
  labelAlign!: string;

  @Watch('labelAlign')
  onLabel_align(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("labelAlign")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  billingCategories!: any;

  async $$load_billingCategories() {
    return this.$fn.fetch('get_tags', { parameters: { tag_type: 'billing_category' } })
  }

  services!: any;

  async $$load_services() {
    return this.$fn.fetch('suggest_product', {
      parameters: { query: '*', top: 50, skip: 0, product_types: 'service', product_invoice_groups: 'all' }
    }).then(data => _.orderBy(data, [p => p.name.toLowerCase()]))
  }

  invoiceGroups!: any;

  async $$load_invoiceGroups() {
    return this.$fn.fetch('list_product_invoice_group')
  }

  ux!: any;
  b_3943151158818434_multiple!: any;
  dataMembers = ['billingCategories', 'services', 'invoiceGroups', 'ux', 'b_3943151158818434_multiple'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        billingCategories: null,
        services: null,
        invoiceGroups: null,
        ux: null,
        b_3943151158818434_multiple: false,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_6466705138206980_setData_9106_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_6466705138206980_setData_9106, alias=undefined
    return {
      path: "item.name",
      value: $event.data.option.name,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_6466705138206980_setData_9108_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_6466705138206980_setData_9108, alias=undefined
    return {
      path: "item.service_id",
      value: $event.data.option.id,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_6466705138206980_setData_9110_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_6466705138206980_setData_9110, alias=undefined
    return {
      path: "feeItem.unit",
      value: $event.data.option.unit,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_6466705138206980_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6466705138206980_optionSelected.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_9104: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_9103: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_6466705138206980_setData_9106: actions.SetDataAction;
    evh_6466705138206980_optionSelected_9105: actions.EventHandlerImpl;
    act_6466705138206980_setData_9108: actions.SetDataAction;
    evh_6466705138206980_optionSelected_9107: actions.EventHandlerImpl;
    act_6466705138206980_setData_9110: actions.SetDataAction;
    evh_6466705138206980_optionSelected_9109: actions.EventHandlerImpl;
    evh_6466705138206980_optionSelected: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_9104 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_9103 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_9104,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_9103],
      }
    );
    const act_6466705138206980_setData_9106 = new actions.SetDataAction(
      {
        actionArgs: this.act_6466705138206980_setData_9106_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_optionSelected_9105 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_setData_9106,
        event: "optionSelected",
        displayName: "setData",
      }
    );
    const act_6466705138206980_setData_9108 = new actions.SetDataAction(
      {
        actionArgs: this.act_6466705138206980_setData_9108_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_optionSelected_9107 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_setData_9108,
        event: "optionSelected",
        displayName: "setData",
      }
    );
    const act_6466705138206980_setData_9110 = new actions.SetDataAction(
      {
        actionArgs: this.act_6466705138206980_setData_9110_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_optionSelected_9109 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_setData_9110,
        event: "optionSelected",
        displayName: "setData",
      }
    );
    const evh_6466705138206980_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_6466705138206980_optionSelected_9105, evh_6466705138206980_optionSelected_9107, evh_6466705138206980_optionSelected_9109],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_9104,
      evh_7315092382398562_reload_9103,
      evh_7315092382398562_reload,
      act_6466705138206980_setData_9106,
      evh_6466705138206980_optionSelected_9105,
      act_6466705138206980_setData_9108,
      evh_6466705138206980_optionSelected_9107,
      act_6466705138206980_setData_9110,
      evh_6466705138206980_optionSelected_9109,
      evh_6466705138206980_optionSelected,
    }
  }
}

Vue.component("FieldsetContractService", FieldsetContractService);

</script>